import { BannerType, ContentFulScreens, ICustomizedBanner, useCms } from "@next-platform/client-common-core";

import { CmsBanner, CmsBannerService } from "@/components";

type HeroBannerProps = {
  screen?: ContentFulScreens;
};

const HeroBanner = ({ screen }: HeroBannerProps) => {
  const { bannerDetails } = useCms();
  const contentFulScreen = screen ?? CmsBannerService.contentfulScreen;
  const bannersGroupedByScreen = bannerDetails?.[contentFulScreen as keyof typeof bannerDetails];
  const bannersGroupedByPlacement = bannersGroupedByScreen?.[BannerType.Top] as ICustomizedBanner[];
  if (bannersGroupedByPlacement?.length) {
    return <CmsBanner placement={BannerType.Top} isVisibleOnPartner={false} screen={screen} />;
  }
  return null;
};

export default HeroBanner;
